import { generateAddress } from '@rentspree/helper'
import PropTypes from 'prop-types'

import { Section, Text } from 'components'
import { useSelector } from 'store'
import {
  selectPublicListingLocation,
  selectPublicListingPropertyAddress,
} from 'store/public-listing'

import { ViewOnGoogleMaps } from '../listing-view-on-google-maps'

import { ListingMap } from './listing-map'
import { ListingStaticMap } from './listing-static-map'

interface IListingMapSection {
  isPreview?: boolean
}

export const ListingMapSection = ({ isPreview }: IListingMapSection) => {
  const position = useSelector(selectPublicListingLocation)
  const propertyAddress = useSelector(selectPublicListingPropertyAddress)
  if (!position) return null

  return (
    <Section title="Location">
      <Text $block $mt="25" $mb={isPreview ? '25' : '0'} $bold>
        {generateAddress(propertyAddress)}
      </Text>
      {isPreview || <ViewOnGoogleMaps destination={position} />}
      {isPreview ? (
        <ListingStaticMap position={position} />
      ) : (
        <ListingMap
          position={position}
          zoom={15}
          nearbyPlaces={{}}
          propertyAddress={propertyAddress}
        />
      )}
    </Section>
  )
}

ListingMapSection.propTypes = {
  isPreview: PropTypes.bool,
}

ListingMapSection.defaultProps = {
  isPreview: false,
}
